import { useEffect, useState } from "react";

export const Waveform = ({ stream }) => {
  const [level, setLevel] = useState(0);

  useEffect(() => {
    if (!stream) return;
    const ctx = new (window.AudioContext || window.webkitAudioContext)();
    const analyser = ctx.createAnalyser();
    analyser.fftSize = 256;
    ctx.createMediaStreamSource(stream).connect(analyser);
    const buf = new Uint8Array(analyser.frequencyBinCount);
    let raf;
    const tick = () => {
      analyser.getByteTimeDomainData(buf);
      let sum = 0;
      for (const v of buf) sum += (v - 128) ** 2;
      setLevel(Math.min(1, Math.sqrt(sum / buf.length) / 40));
      raf = requestAnimationFrame(tick);
    };
    tick();
    return () => { cancelAnimationFrame(raf); ctx.close(); };
  }, [stream]);

  const bars = [0.5, 0.8, 1, 0.7, 0.9, 0.6, 1, 0.8, 0.5];
  return (
    <div data-testid="audio-waveform-container" className="h-12 mb-2 rounded-xl bg-indigo-50 border border-indigo-100 px-4 flex items-center justify-between">
      <span className="text-xs font-medium text-indigo-700 flex items-center gap-2">
        <span className="w-2 h-2 rounded-full bg-red-500 animate-pulse" /> Listening
      </span>
      <div className="flex items-center gap-1 h-8">
        {bars.map((b, i) => (
          <span key={i} className="w-1 rounded-full bg-indigo-500 transition-[height] duration-75" style={{ height: `${4 + level * 28 * b}px` }} />
        ))}
      </div>
    </div>
  );
};
